import { render, staticRenderFns } from "./SurveyInput.vue?vue&type=template&id=36ebf7d4&"
import script from "./SurveyInput.vue?vue&type=script&lang=js&"
export * from "./SurveyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports